export default function copyLink(el, dataEl) {
    const link = el.getAttribute(`data-${dataEl}`);
    let listener = function(ev) {
        ev.clipboardData.setData("text/plain", link);
        ev.preventDefault();
    };
    document.addEventListener("copy", listener);
    document.execCommand("copy");
}